/**
 * Step 1 and step 2 validation — same rules as main project (validation keys + t('errors.${key}')).
 */
import {
  getEmailError,
  getNameError,
  getCountryError,
  getPhoneError,
  getMessageError,
  normalizeWhitespace,
} from '../utils/validation'
import type { FormState } from './useContactFormState'

export function useContactFormValidation(
  form: { value: FormState },
  errors: { value: Partial<Record<keyof FormState, string>> },
  t: (key: string) => string,
  setError: (key: keyof FormState, msg: string) => void,
  shake: () => void
) {
  function validateStep1(): boolean {
    let ok = true
    const emailKey = getEmailError(form.value.email)
    if (emailKey) {
      setError('email', t(`errors.${emailKey}`))
      ok = false
    }
    if (!form.value.acceptPrivacyPolicy) {
      setError('acceptPrivacyPolicy', t('errors.privacy_required'))
      ok = false
    }
    if (!ok) shake()
    return ok
  }

  function validateStep2(): boolean {
    let ok = true
    const first = normalizeWhitespace(form.value.firstName)
    const last = normalizeWhitespace(form.value.lastName)
    const country = form.value.country.trim().toUpperCase()
    const phone = form.value.phone.trim()
    const msg = form.value.message.trim()

    const firstKey = getNameError(first)
    if (firstKey) {
      setError('firstName', t(`errors.${firstKey}`))
      ok = false
    }
    const lastKey = getNameError(last)
    if (lastKey) {
      setError('lastName', t(`errors.${lastKey}`))
      ok = false
    }
    const countryKey = getCountryError(country)
    if (countryKey) {
      setError('country', t(`errors.${countryKey}`))
      ok = false
    }
    const phoneKey = getPhoneError(phone)
    if (phoneKey) {
      setError('phone', t(`errors.${phoneKey}`))
      ok = false
    }
    const msgKey = getMessageError(msg)
    if (msgKey) {
      setError('message', t(`errors.${msgKey}`))
      ok = false
    }
    if (!ok) shake()
    return ok
  }

  return { validateStep1, validateStep2 }
}
